// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import UserRoutes from './routes/UserRoutes';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function App() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" />
      <UserRoutes />
    </BrowserRouter>
  );
}
